import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Page, Box } from 'core/ui/atoms';

const SplitPageSidebar = ({ children, sidebarView, sidebarWidth, isModal = false }) => {
  const BackgroundComponent = isModal ? ModalBackground : Background;
  const PageContainer = isModal ? Box : Page;

  return (
    <PageContainer scrollTop>
      <BackgroundComponent>
        <ChildrenContainer>
          {children}
        </ChildrenContainer>
        <LeftSidebar sidebarWidth={sidebarWidth}>
          {sidebarView}
        </LeftSidebar>
      </BackgroundComponent>
    </PageContainer>
  );
};

SplitPageSidebar.propTypes = {
  children: PropTypes.node,
  sidebarView: PropTypes.node,
  sidebarWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isModal: PropTypes.bool,
};

SplitPageSidebar.defaultProps = {
  sidebarWidth: '30%',
};

const ChildrenContainer = styled(Box)`
  width: 100%;
  ${(p) => p.theme.min('md')`
    width: 60%;
    flex-grow: 1;
    margin-right: 20px;
    padding-left: 60px;
    padding-right: 0px;
  `}
`;

const LeftSidebar = styled(Box)`
  width: ${(p) => p.sidebarWidth || '30%'};
  flex-shrink: 0;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${(p) => p.theme.max('md')`
    display: none;
  `}
`;

const Background = styled.div`
  width: 100%;
  ${(p) => p.theme.min('md')`
    min-height: calc(100vh - ${(p) => p.theme.layout.headerHeight});
    display: flex;
    flex-direction: row;
    padding: 0px;
  `}
`;

const ModalBackground = styled.div`
  width: 100%;
  ${(p) => p.theme.min('md')`
    min-height: calc(60vh);
    display: flex;
    flex-direction: row;
    padding: 0px;
  `}
`;

export default SplitPageSidebar;
